const getSavedPostcode = () => {
  const lsItems = localStorage.getItem('userLocation'); // Otherwise, convert the localStorage string to an array
  const location = JSON.parse(lsItems);
  if (location && location.postcode && location.postcode.length === 4) {
    return location.postcode
  } else {
    return null
  }
}

export default getSavedPostcode